export enum ViewType {
    NONE = 'view-type-none',
    ALL = 'view-type-all',
    PARTIAL = 'view-type-partial'
}
